<template>
  <div class="partner-container" v-if="types.length > 0">
    <div class="partner-top">合作伙伴</div>
    <div class="partner-tabs" v-if="false">
      <div
        class="partner-tab"
        :class="{ active: index === currentIndex }"
        v-for="(type, index) in currentTypes"
        :key="index"
        @click="changeIndex(index)"
      >
        <div v-if="index === 0" class="first-active-bg"></div>
        <div v-else class="active-bg"></div>
        <img class="tab-bg" src="../../assets/images/partner/pc/tab-bg.png" />
        {{ type.title }}
        <div class="active-bottom"></div>
      </div>
    </div>
    <div class="partner-content">
      <div class="partner-box">
        <div
          class="partner-item"
          v-for="(item, index) in currentList"
          :key="index"
          @mouseleave="partner_hover(item)"
        >
          <img :src="item.coverImageRealPath_new" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Partner",
  props: {
    partnerid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      types: [],
      currentIndex: 0,
      list: [],
      firstType: {
        title: "",
        coverImageRealPath: "",
      },
    };
  },
  computed: {
    currentTypes() {
      let types = this.types;
      types = types.sort((a, b) => {
        a.sort = a.articleCategoryId === this.$config.partnerId ? 999 : 0;
        b.sort = b.articleCategoryId === this.$config.partnerId ? 999 : 0;
        return a.sort - b.sort;
      });
      return types;
    },
    currentList() {
      let list = this.currentTypes[0].items;
      list.forEach((item) => {
        item.coverImageRealPath_new = "";
        if (item.coverImageRealPath) {
          item.coverImageRealPath_new = item.coverImageRealPath.replace(
            /^.*\/\/hwyhw.smarket.net.cn/,
            "https://hwyhw-files.smarket.net.cn"
          );
        }
      });
      return list;
    },
  },
  // watch: {
  //   //固定类型位置
  //   types: function (newVal, oldVal) {
  //     if (newVal.length == 2) {
  //       if (newVal[0].title == "区域合作伙伴") {
  //         return;
  //       } else {
  //         let newArr = [newVal[1], newVal[0]];
  //         this.types = newArr;
  //       }
  //     }
  //   },
  // },
  mounted() {
    this.getList(this.partnerid);
  },
  methods: {
    more() {
      this.$router.push({
        path: "/partner",
      });
    },
    changeIndex(index) {
      const currentItem = this.types[index];
      this.currentIndex = index;
      this.list = currentItem.items;
    },
    async getList(id) {
      const categoryRoot = {
        total: 0,
        title: "大会合作伙伴",
        items: [],
        articleCategoryId: 0,
      };
      const types = [];
      this.$api.getPartnerList(this.$config.partnerId).then((resRoot) => {
        const list = resRoot.content.items.sort((a, b) => {
          return b.order - a.order;
        });
        categoryRoot.total = list.length;
        categoryRoot.items = list;
        categoryRoot.articleCategoryId = this.$config.partnerId;
        types.push(categoryRoot);
        this.types = types;
        if (id) {
          this.$api
            .getStaticArticleCategory(this.$config.subPartnerId)
            .then((res) => {
              const currentItem = res.content.items.find((item) => {
                return item.articleCategoryId == id;
              });
              currentItem.subCategories.forEach((category) => {
                this.$api
                  .getStaticArticleList(category.articleCategoryId)
                  .then((articleRes) => {
                    category.items = articleRes.content.items.sort((a, b) => {
                      return b.order - a.order;
                    });
                    if (!this.list.length) {
                      this.list = category.items;
                    }
                    category.total = articleRes.content.total;
                    if (category.total > 0) {
                      types.push(category);
                      this.types = types;
                    }
                  });
              });
            });
        } else {
          this.list = categoryRoot.items;
          this.types = types;
        }
      });
    },
    //埋码 悬浮时间
    partner_hover(option) {
      //埋码
      window._hw("send", "action", "branch_venue_page_partner_click", {
        partner_name: option.title,
        venue_name: this.$route.query.i_offlineArea,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
//MOBILE
@media screen and (max-width: 992px) {
  .partner-container {
    padding: 60px 35px 0;
    width: 100%;

    .partner-top {
      font-size: 28px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #151e26;
      padding-bottom: 15px;
      background: url("../../assets/images/parallelSessions/title-border-pc.png");
      background-repeat: no-repeat;
      background-position: bottom left;
      background-size: 117px 4.5px;
    }
    .partner-header {
      background-image: url("../../assets/images/partner/pc/header-bg.png");
      background-repeat: no-repeat;
      margin-top: 32px;
      border: 1px solid;
      border-image: linear-gradient(
          340deg,
          rgba(255, 255, 255, 1),
          rgba(255, 255, 255, 0)
        )
        2 2;
      filter: blur(undefinedpx);
      position: relative;

      .partner-header-left {
        width: 275px;
        height: 110px;
        position: absolute;
        bottom: 0;
        left: 0;
      }

      .partner-header-right {
        width: 301px;
        height: 135px;
        position: absolute;
        bottom: 0;
        right: 0;
      }

      .logo-image {
        width: 265px;
      }

      .title {
        padding-top: 48px;
        font-size: 24px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        color: #151e26;
        padding-bottom: 30px;
        text-align: center;
        width: 100%;
      }

      .logo {
        text-align: center;
        width: 100%;
        padding-bottom: 63px;
      }
    }

    .partner-tabs {
      font-size: 28px;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;

      color: #999999;
      margin-top: 30px;
      height: 106px;
      background-image: url("../../assets/images/partner/pc/tabs-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border: 1px solid;
      border-image: linear-gradient(
          7deg,
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 0.62)
        )
        2 2;
      filter: blur(undefinedpx);
      display: flex;
      flex-wrap: nowrap;
      overflow-x: scroll;
      overflow-y: hidden;

      white-space: nowrap;

      //&::-webkit-scrollbar {
      //  display: none;
      //}

      .partner-tab {
        padding-left: 20px;
        flex-shrink: 0;
        width: 194px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        position: relative;

        .tab-bg {
          position: absolute;
          top: 0;
          left: 0;
          background: url("../../assets/images/partner/wap/tab-bg.png");
          background-size: 100% 100%;
          width: 85px;
          height: 106px;
        }

        .active-bg,
        .first-active-bg {
          display: none;
          z-index: 1;
          pointer-events: none;
        }

        &:first-child {
          .tab-bg {
            display: none;
            z-index: 2;
          }
        }
        &:not(:first-child) {
          padding-left: 40px;
        }

        &.active {
          color: #b4251e;
          font-family: Microsoft YaHei-Light;
          font-weight: 900;
          position: relative;

          .first-active-bg {
            position: absolute;
            top: -2px;
            right: -12px;
            width: calc(100% + 20px);
            height: calc(100% + 2px);
            background: url("../../assets/images/partner/wap/first-active-bg.png");
            background-size: 224px 106px;
            display: block;
          }

          .active-bg {
            position: absolute;
            top: 0;
            left: 0;
            height: 106px;
            background: url("../../assets/images/partner/wap/active-bg.png");
            background-size: 329px 106px;
            display: block;
            width: 289px;
          }

          .active-bottom {
            position: absolute;
            bottom: 0;
            left: calc(50% - 45px + 10px);
            width: 90px;
            height: 4px;
            background: #b4251e;
          }
        }
      }
    }

    .partner-content {
      height: 604px;
      padding: 20px 10px;
      width: 100%;
      background: rgba(255, 255, 255, 0.22);
      border: 1px solid;
      margin-top: 37px;
      border-image: linear-gradient(
          160deg,
          rgba(255, 255, 255, 1),
          rgba(235, 235, 235, 0),
          rgba(235, 235, 235, 0),
          rgba(255, 255, 255, 0.62)
        )
        2 2;

      .partner-box {
        padding-top: 40px;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: flex-start;

        .partner-item {
          width: calc(100% / 3);
          overflow: hidden;
          padding-bottom: 80px;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            width: 130px;
          }
        }
      }
    }
    .link-new {
      width: 100%;
      height: 30px;
      margin-top: 30px;
      font-size: 12px;
      span {
        height: 30px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #b4251e;
        line-height: 30px;
        font-size: 24px;
        border-bottom: 1px solid #b4251e;
        padding-bottom: 1px;
      }
    }

    .partner-more {
      width: 140px;
      margin-left: calc(50% - 70px);
      margin-top: 23px;
      cursor: pointer;
      font-size: 24px;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      color: #b4251e;
      text-align: center;
      border-bottom: 1px solid #b4251e;
      padding-bottom: 1px;
    }
  }
}

//PC
@media screen and (min-width: 992px) {
  .partner-container {
    margin-top: 50px;
    width: 1500px;

    .partner-top {
      font-size: 32px;
      font-family: Microsoft YaHei-Light;
      font-weight: bold;
      width: 130px;
      padding-bottom: 15px;
      background: url("../../assets/images/parallelSessions/title-border-pc.png");
      background-size: 130px 5px;
      background-repeat: no-repeat;
      background-position: bottom;
    }
    .partner-tabs {
      font-size: 18px;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      color: #4f4f4f;
      margin-top: 30px;
      height: 80px;
      margin-left: -2px;
      background-image: url("../../assets/images/parallelSessions/partner-tabs-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border: 1px solid;
      border-image: linear-gradient(
          7deg,
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 0.62)
        )
        2 2;
      filter: blur(undefinedpx);
      display: flex;

      .partner-tab {
        width: 232px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        position: relative;
        font-family: Microsoft YaHei-Regular;
        font-weight: 400;
        font-size: 18px;
        color: #999999;

        .tab-bg {
          background: url("../../assets/images/partner/pc/tab-bg.png");
          background-size: 100% 100%;
          position: absolute;
          left: -10px;
          top: 0;
          width: 77px;
          height: 80px;
          z-index: 2;
        }

        .active-bg,
        .first-active-bg {
          display: none;
          z-index: 1;
        }

        &:first-child {
          .tab-bg {
            display: none;
            z-index: 2;
          }
        }

        &:hover {
          font-size: 18px;
          font-family: Microsoft YaHei-Light;
          font-weight: bold;
          color: #b4251e;
          .first-active-bg {
            background: url("../../assets/images/partner/pc/first-active-bg.png");
            background-size: 100% 100%;
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            width: 242px;
            height: 80px;
            z-index: 1;
          }

          .active-bg {
            background: url("../../assets/images/partner/pc/active-bg.png");
            background-size: 100% 100%;
            display: block;
            position: absolute;
            left: -10px;
            top: 0;
            width: 252px;
            height: 80px;
            z-index: 1;
          }
        }

        &.active {
          position: relative;
          font-size: 18px;
          font-family: Microsoft YaHei-Light;
          font-weight: bold;
          color: #b4251e;
          .first-active-bg {
            background: url("../../assets/images/partner/pc/first-active-bg.png");
            background-size: 100% 100%;
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            width: 242px;
            height: 80px;
            z-index: 1;
          }

          .active-bg {
            background: url("../../assets/images/partner/pc/active-bg.png");
            background-size: 100% 100%;
            display: block;
            position: absolute;
            left: -10px;
            top: 0;
            width: 252px;
            height: 80px;
            z-index: 1;
          }

          .active-bottom {
            position: absolute;
            bottom: 0;
            left: calc(50% - 50px);
            width: 100px;
            height: 3px;
            background: #c7000b;
          }
        }
      }
    }

    .partner-content {
      height: 423px;
      padding: 20px 10px;
      width: 100%;
      background: rgba(255, 255, 255, 0.22);
      border: 1px solid;
      margin-top: 22px;
      border-image: linear-gradient(
          160deg,
          rgba(255, 255, 255, 1),
          rgba(235, 235, 235, 0),
          rgba(235, 235, 235, 0),
          rgba(255, 255, 255, 0.62)
        )
        2 2;

      .partner-box {
        padding-top: 40px;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        align-content: baseline;
        justify-content: flex-start;

        .partner-item {
          width: calc(100% / 6 - 20px);
          height: 80px;
          overflow: hidden;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 30px;
          margin-left: 10px;
          margin-right: 10px;

          img {
            width: 150px;
            flex-shrink: 0;
            &:hover {
              width: 180px;
            }
          }
        }
        @media screen and (-ms-high-contrast: active),
          (-ms-high-contrast: none) {
          /*兼容IE11*/
          .partner-item {
            width: 220px;
            overflow: hidden;
            margin-bottom: 30px;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            height: 80px;

            img {
              width: 150px;
              flex-shrink: 0;
              &:hover {
                width: 180px;
              }
            }
          }
        }
      }
    }

    .partner-more {
      width: 100px;
      margin: 38px auto 0 auto;
      cursor: pointer;
      font-size: 16px;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      color: #b4251e;
      text-align: center;
      border-bottom: 1px solid #b4251e;
      padding-bottom: 1px;
    }
  }
}
</style>
